import React from "react";
import IAuxRenderParams from "@cayo/shared/components/schemes/types/AuxRenderProps";
import BasicList from "./BasicList";
import ODataFacts from "./ODataFacts";
import { IBasicList, IFacts } from "../../api/schema.api";

const basiclist = (props: IBasicList, auxParams: IAuxRenderParams) => (
  <BasicList {...props} {...auxParams} />
);

const facts = (props: IFacts) => <ODataFacts {...props} />;

const listRenderers = {
  basiclist,
  facts,
};

export default listRenderers;
